(function () {
	const initProductSpecs = (root) => {
		if (!root || root.dataset.specsReady === 'true') return

		const tabs = Array.from(root.querySelectorAll('[data-spec-tab]'))
		const panels = Array.from(root.querySelectorAll('[data-spec-panel]'))
		if (!tabs.length || !panels.length) return

		const activate = (index) => {
			tabs.forEach((tab, i) => {
				const selected = i === index
				tab.setAttribute('aria-selected', selected ? 'true' : 'false')
				tab.setAttribute('tabindex', selected ? '0' : '-1')
			})
			panels.forEach((panel, i) => {
				panel.hidden = i !== index
			})
		}

		tabs.forEach((tab, index) => {
			tab.addEventListener('click', () => activate(index))
			tab.addEventListener('keydown', (event) => {
				if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return
				event.preventDefault()
				const next =
					event.key === 'ArrowRight'
						? (index + 1) % tabs.length
						: (index - 1 + tabs.length) % tabs.length
				activate(next)
				tabs[next].focus()
			})
		})

		const initial = Math.max(
			0,
			tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true')
		)
		activate(initial)
		root.dataset.specsReady = 'true'
	}

	const initAll = () => {
		document.querySelectorAll('[data-product-specs]').forEach(initProductSpecs)
	}

	initAll()
	document.addEventListener('shopify:section:load', initAll)
})()
